<style scoped> 
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="col-md-6 col-sm-12 mt-5">
        <div class="form-group">
            <label class="label"> {{ $t('Country') }} </label>
            <h2>{{ addMaster?.country?.name }}</h2>
        </div>
        <div class="form-group">
            <label class="label">{{ $t('Category product') }}</label>
            <h2>{{ addMaster?.category?.name }}</h2>
        </div>
        <br><br>
        <div class="form-group mb-2 mb-md-0">
            <label class="label" for="note">{{ $t('Additional info') }}</label>
            <textarea 
                placeholder="Additional info"
                id="note"
                class="form-control" 
                v-model="note" 
                rows="2"
                :required="true"
                :disabled="read" >
            </textarea>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'AdditionalInfo',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            addMaster: {
                type: [String, Number, Object],
                required: true
            },
            read : {
                type : Boolean,
                default : false
            }
        },
        computed: {
            note: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>